// extracted by mini-css-extract-plugin
export var base = "footer-module--base--adcd4";
export var content = "footer-module--content--fe2b4";
export var footerWrapper = "footer-module--footerWrapper--aa7d3";
export var logo = "footer-module--logo--e2970";
export var nav = "footer-module--nav--d8727";
export var pressKitBase = "footer-module--pressKitBase--dfc97";
export var pressKitContent = "footer-module--pressKitContent--92c45";
export var socialsWrapper = "footer-module--socialsWrapper--b89ac";